import { render, staticRenderFns } from "./ColumnTransactionStatusAdyen.vue?vue&type=template&id=24b3f3db&scoped=true"
import script from "./ColumnTransactionStatusAdyen.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusAdyen.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusAdyen.vue?vue&type=style&index=0&id=24b3f3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3f3db",
  null
  
)

export default component.exports